import React, { useCallback } from 'react';
import Navbar, { hideNavbar } from "./Navbar/Navbar";

const Layout =({children, language, updateLanguage, getLanguage, containerWidth, containerHeight, updateContainerWidth, getContainerWidth, updateContainerHeight, getContainerHeight }) => {
    const mainContainer = useCallback(node => {
        if (node !== null) {
            updateContainerWidth(node.getBoundingClientRect().width);
            updateContainerHeight(node.getBoundingClientRect().height);
        }
    }, []);

    return(
        <>
            <Navbar
                flag={language.data.flag}
                updateLanguage={updateLanguage}
                getLanguage={getLanguage}
                updateContainerWidth={updateContainerWidth}
                getContainerWidth={getContainerWidth}
                updateContainerHeight={updateContainerHeight}
                getContainerHeight={getContainerHeight}
            />
            <main
                ref={mainContainer}
                  language={language}
                  containerwidth={containerWidth}
                  containerheight={containerHeight}
                  onClick={hideNavbar}
                  className="container">{children}
            </main>
        </>
    )
}

export default Layout;